import React from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Tabs,
  Tab,
  Modal,
} from "react-bootstrap";
import { getAllSubscriptionAction } from "./../../../actions/SubscriptionAction";
import { activateSubscriptionAction } from "./../../../actions/ChangePlanActions";
import * as code from "./../../../config/Constants";
import { connect } from "react-redux";
import { currencyFormat, toastMessage } from "./../../Common/Common";

class ActivatePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthData: [],
      yearData: [],
      showLoader: false,
      activateModal: false,
      newPriceId: "",
      price: "",
      name: "",
      interval: "",
    };
  }
  componentWillMount() {
    this.setState({ showLoader: true });
    // this.props.getAllSubscriptionAction("month").then(monthRes => {
    //     this.setState({ showLoader: false });
    //     if (monthRes.status === code.OK) {
    //         this.setState({ monthData: monthRes.data });
    //     }
    // });
    // this.props.getAllSubscriptionAction("year").then(yearRes => {
    //     this.setState({ showLoader: false });
    //     if (yearRes.status === code.OK) {
    //         this.setState({ yearData: yearRes.data });
    //     }
    // })
  }
  /**
   * @desc activate plan
   */
  activateSubscription() {
    this.setState({ showLoader: true });
    let data = {
      priceId: this.state.newPriceId,
    };
    this.props.activateSubscriptionAction(data).then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        this.setActivateModal();
        localStorage.setItem(
          "isActive",
          !!res.data.subsriptionDetails
            ? res.data.subsriptionDetails.isActive
            : "true"
        );
        localStorage.setItem(
          "priceId",
          !!res.data.subsriptionDetails
            ? res.data.subsriptionDetails.priceId
            : ""
        );
        toastMessage(code.SUCCESS, "Plan activated successfully");
        this.props.history.replace("/Subscription/SubscriptionDetail");
      }
    });
  }

  setActivateModal() {
    this.setState({ activateModal: !this.state.activateModal });
  }
  render() {
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <Row className="mx-0 page-head-row page-head-row-big align-items-center">
              <Col>
                <h4 className="title-med mt-0 pt-1">Activate Plan</h4>
              </Col>
            </Row>
            <div className="container-custom pricing">
              <Tabs
                defaultActiveKey="monthly"
                id="uncontrolled-tab-example"
                className="subscription-tabs"
              >
                <Tab eventKey="monthly" title="Monthly">
                  <Row>
                    {this.state.monthData.map((monthData) => {
                      if (monthData.price.isActive && monthData.isActive) {
                        let description =
                          "<div>" + monthData.description + "</div>";
                        return (
                          <Col
                            lg={3}
                            md={6}
                            sm={6}
                            className={`plan-scheme ${
                              localStorage.getItem("priceId") ===
                              monthData.price.price
                                ? "active-plan"
                                : ""
                            }`}
                          >
                            <Card className="transaction-single">
                              <Card.Body>
                                <h4>{monthData.name}</h4>
                                <p className="plan-price">
                                  {currencyFormat(monthData.price.unit_amount)}
                                  /mo.
                                </p>
                                <div className="plan-desc">
                                  <label>Description</label>
                                  <p
                                    className="plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: monthData.description,
                                    }}
                                  />
                                  <div
                                    className="more-plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                </div>
                                <Button
                                  variant="primary"
                                  className="btn-blue w-140"
                                  onClick={() =>
                                    this.setState({
                                      activateModal: true,
                                      newPriceId: monthData.price.price,
                                      name: monthData.name,
                                      price: monthData.price.unit_amount,
                                      interval:
                                        monthData.price.recurring.interval,
                                    })
                                  }
                                >
                                  ACTIVATE PLAN
                                </Button>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      }
                    })}
                  </Row>
                </Tab>
                <Tab eventKey="annually" title="Annually">
                  <Row>
                    {this.state.yearData.map((yearData) => {
                      if (yearData.price.isActive && yearData.isActive) {
                        let description =
                          "<div>" + yearData.description + "</div>";

                        return (
                          <Col
                            lg={3}
                            md={6}
                            sm={6}
                            className={`plan-scheme ${
                              localStorage.getItem("priceId") ===
                              yearData.price.price
                                ? "active-plan"
                                : ""
                            }`}
                          >
                            <Card className="transaction-single">
                              <Card.Body>
                                <h4>{yearData.name}</h4>
                                <p className="plan-price">
                                  {currencyFormat(yearData.price.unit_amount)}
                                  /yr.
                                </p>
                                <div className="plan-desc">
                                  <label>Description</label>
                                  <p
                                    className="plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: yearData.description,
                                    }}
                                  />
                                  <div
                                    className="more-plan-text"
                                    dangerouslySetInnerHTML={{
                                      __html: description,
                                    }}
                                  />
                                </div>
                                <Button
                                  variant="primary"
                                  className="btn-blue w-140"
                                  onClick={() => {
                                    this.setState({
                                      activateModal: true,
                                      newPriceId: yearData.price.price,
                                      name: yearData.name,
                                      price: yearData.price.unit_amount,
                                      interval:
                                        yearData.price.recurring.interval,
                                    });
                                  }}
                                >
                                  ACTIVATE PLAN
                                </Button>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      }
                    })}
                  </Row>
                </Tab>
              </Tabs>
            </div>
            <Modal
              show={this.state.activateModal}
              onHide={() => this.setActivateModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med1 add-payment-method"
              centered
            >
              <Form className="form-sm form-admin">
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Activate Subscription Plan
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h6 className="mb-3 mt-2">Subscription plan details</h6>
                  <p>Plan: &nbsp; {this.state.name}</p>
                  <p>
                    Price: &nbsp;{currencyFormat(this.state.price)}
                    {this.state.interval === "month" ? "/mo." : "/yr."}
                  </p>
                </Modal.Body>
                <Modal.Footer className="modal-footer-btn-center">
                  <Button
                    variant="primary"
                    className="btn-blue btn-outlined w-140"
                    onClick={() => {
                      this.setActivateModal();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    className="btn-blue w-140"
                    onClick={() => {
                      this.activateSubscription();
                    }}
                  >
                    Confirm Plan
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
export default connect(
  mapStateToProps,
  {
    getAllSubscriptionAction,
    activateSubscriptionAction,
  }
)(ActivatePlan);
